export default __webpack_public_path__ + "static/media/6.e0a9319e.webp";